/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Card } from '../../../Shared/Card'
import { useQuery } from '@tanstack/react-query'
import useUser from '../../../../Shared/UserProvider/useUser'
import { getCheckoutSystem } from '../../../../../services/PointOfSale/PointOfSale.service'
import { NoCheckoutSystemCardContent } from './NoCheckoutSystemCardContent'
import { TIME } from '../../../../../services/date.service'
import { LoadingPlaceholderCardContent } from '../../../Shared/LoadingPlaceholderCardContent'
import { THEME_COLORS } from '../../../../Shared/theme'
import { CheckoutSystemCardContent } from './CheckoutSystemCardContent'
import { useDeviceMediaQuery } from '../../../../Shared/UseDeviceMediaQuery/useDeviceMediaQuery'


const CheckoutSystemCard = () => {
    const {user} = useUser()
    const { isMobile } = useDeviceMediaQuery()

    const {data, isLoading} = useQuery({
        queryKey: ['checkout-system', user.provider.object.id],
        queryFn: () => getCheckoutSystem(user.provider.object.id),
        staleTime: TIME.MINUTE_IN_MS * 5,
    })

    const getBorderColor = () => {
        if (isLoading) {
            return 'unset'
        }

        if (!data || data.state === undefined) {
            return 'grey'
        }

        return data.state.status === 'OK' ? THEME_COLORS.GREEN : THEME_COLORS.RED
    }

    return (
      <Card
        css={css`
            border-top: 2px solid ${getBorderColor()};

            .card-content {
                width: ${isMobile ? '340px' : '360px'};
                height: 110px;
            }
        `}
      >
          {isLoading ? (
            <LoadingPlaceholderCardContent/>
          ) : !data ? <NoCheckoutSystemCardContent/> : (
            <CheckoutSystemCardContent data={data} />
          )}
      </Card>
    )
}

export { CheckoutSystemCard }
